import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href", "title", "target"]
const _hoisted_2 = { class: "a-arrow-link__text" }
const _hoisted_3 = {
  class: "a-arrow-link__icon",
  "aria-hidden": "true",
  width: "26",
  height: "14",
  viewBox: "0 0 26 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", {
    class: _normalizeClass(["a-arrow-link", [_ctx.colourClasses]]),
    href: _ctx.href,
    title: _ctx.title,
    target: _ctx.target
  }, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.content), 1),
    (_openBlock(), _createElementBlock("svg", _hoisted_3, [
      _createElementVNode("path", {
        class: _normalizeClass([_ctx.colourClasses]),
        d: "M18.1928 10.2644C17.5715 10.4624 17.0537 10.6275 16.5359 10.8035C14.4337 11.5516 12.2797 11.9917 10.0947 12.3217C8.47922 12.5638 6.87409 12.9048 5.27932 13.2899C4.27482 13.532 3.28068 13.587 2.27618 13.4329C1.62378 13.3339 1.16813 13.0039 0.981727 12.2997C0.5675 10.7595 0.173986 9.21921 0.111852 7.61293C0.101497 7.28288 0.049719 6.95282 0.018652 6.62276C-0.157394 4.45539 0.919596 3.17916 2.95966 3.20116C4.56479 3.22316 6.16991 3.30018 7.78539 3.3992C10.3225 3.54222 12.8597 3.72926 15.4072 3.89429C16.0492 3.93829 16.6913 3.99331 17.4369 4.04832C17.323 3.72926 17.2194 3.46521 17.1365 3.19016C16.9709 2.58506 16.7534 1.99096 16.6602 1.36385C16.5359 0.516702 17.0951 -0.0884075 17.9029 0.0106096C18.3067 0.0546172 18.7313 0.175641 19.0834 0.384677C19.9222 0.86876 20.7714 1.36385 21.5481 1.96895C22.7804 2.93712 23.9506 3.9823 25.1415 5.00548C25.2657 5.10449 25.3797 5.22551 25.4832 5.33553C26.1045 6.00665 26.177 6.56774 25.6385 7.31587C25.069 8.09701 24.4683 8.87814 23.8159 9.58226C22.5422 10.9575 21.2374 12.2997 19.9119 13.62C19.4044 14.1261 19.1973 14.0931 18.6795 13.719C18.3792 13.499 18.3274 13.2129 18.3171 12.8608C18.3067 12.0467 18.2446 11.2216 18.1928 10.2644Z"
      }, null, 2)
    ]))
  ], 10, _hoisted_1))
}